(function () {
  var body = document.body;

  // Menu drawer
  var drawer = document.getElementById('MenuDrawer');
  if (drawer) {
    var openers = document.querySelectorAll('[data-menu-open]');
    var setOpen = function (open) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      body.style.overflow = open ? 'hidden' : '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var f = drawer.querySelector('[data-menu-close]'); if (f) f.focus(); }
    };
    openers.forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    drawer.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  // Tabs
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('[role="tab"]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        wrap.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = p.id !== btn.getAttribute('aria-controls'); });
      });
    });
  });

  // Carousels: prev/next buttons drive the visible track in the same section
  var stepCarousel = function (btn, dir) {
    var scope = btn.closest('.section') || document;
    var track = Array.prototype.find.call(scope.querySelectorAll('.carousel__track'), function (t) { return t.offsetParent !== null; });
    if (!track) return;
    var item = track.firstElementChild;
    var w = item ? item.getBoundingClientRect().width + 24 : track.clientWidth;
    track.scrollBy({ left: dir * w, behavior: 'smooth' });
  };
  document.querySelectorAll('[data-carousel-prev]').forEach(function (b) { b.addEventListener('click', function () { stepCarousel(b, -1); }); });
  document.querySelectorAll('[data-carousel-next]').forEach(function (b) { b.addEventListener('click', function () { stepCarousel(b, 1); }); });

  // Reveal on scroll
  if (body.classList.contains('has-reveal') && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('main .shopify-section .page-width > *, main .shopify-section .hero__content > *');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { t.classList.add('reveal'); io.observe(t); });
  }

  // Section dots
  if (body.classList.contains('has-dots')) {
    var sections = Array.prototype.slice.call(document.querySelectorAll('main > .shopify-section'));
    if (sections.length > 2) {
      var nav = document.createElement('nav');
      nav.className = 'section-dots';
      nav.setAttribute('aria-label', 'Page sections');
      var dots = sections.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to section ' + (i + 1));
        b.addEventListener('click', function () { s.scrollIntoView({ behavior: 'smooth' }); });
        nav.appendChild(b);
        return b;
      });
      body.appendChild(nav);
      var dio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = sections.indexOf(e.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          nav.classList.toggle('on-light', !!e.target.querySelector('.section--light, .find-us'));
        });
      }, { threshold: 0.5 });
      sections.forEach(function (s) { dio.observe(s); });
    }
  }

  // Text-us widget dismiss
  document.querySelectorAll('[data-text-us-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      var w = b.closest('.text-us');
      if (w) w.classList.add('is-dismissed');
      try { sessionStorage.setItem('textUsDismissed', '1'); } catch (e) {}
    });
  });
  try {
    if (sessionStorage.getItem('textUsDismissed')) document.querySelectorAll('.text-us').forEach(function (w) { w.classList.add('is-dismissed'); });
  } catch (e) {}

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.hasAttribute('data-plus') ? 1 : -1;
        var min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submit = form.querySelector('[type="submit"]');
    var money = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };
    form.addEventListener('change', function () {
      var selected = Array.prototype.map.call(form.querySelectorAll('[data-option]:checked'), function (i) { return i.value; });
      if (!selected.length) return;
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (submit) {
        submit.disabled = !match.available;
        submit.querySelector('span').textContent = match.available ? submit.dataset.addLabel : submit.dataset.soldLabel;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();

/* ---------- Damage photo uploader (Cloudinary unsigned upload → links in enquiry email) ---------- */
(function () {
  var MAX_EDGE = 2000;      // resize long edge before upload
  var MAX_BYTES = 20 * 1024 * 1024;

  function resize(file) {
    return new Promise(function (resolve) {
      if (!/^image\/(jpe?g|png|webp|heic|heif)$/i.test(file.type) || !window.createImageBitmap) return resolve(file);
      createImageBitmap(file).then(function (bmp) {
        var s = Math.min(1, MAX_EDGE / Math.max(bmp.width, bmp.height));
        if (s === 1 && file.size < 3 * 1024 * 1024) return resolve(file);
        var c = document.createElement('canvas');
        c.width = Math.round(bmp.width * s); c.height = Math.round(bmp.height * s);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (b) { resolve(b ? new File([b], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.85);
      }).catch(function () { resolve(file); });
    });
  }

  document.querySelectorAll('[data-photo-upload]').forEach(function (wrap) {
    var form = wrap.closest('form');
    var input = wrap.querySelector('input[type="file"]');
    var list = wrap.querySelector('.photo-upload__list');
    var drop = wrap.querySelector('.photo-upload__drop');
    var errorEl = wrap.querySelector('.photo-upload__error');
    var urlsField = wrap.querySelector('[data-photo-urls]');
    var submit = form && form.querySelector('[type="submit"]');
    var max = parseInt(wrap.dataset.max || '5', 10);
    var required = wrap.dataset.required === 'true';
    var ready = wrap.dataset.ready === 'true';
    var endpoint = 'https://api.cloudinary.com/v1_1/' + wrap.dataset.cloud + '/image/upload';
    var items = []; // {id, el, status: uploading|done|error, url}
    var seq = 0;

    if (!ready) {
      // Uploads not configured yet: keep the form working, point customers to SMS instead.
      drop.style.display = 'none';
      errorEl.hidden = false;
      errorEl.style.color = '#444';
      var sms = document.querySelector('a[href^="sms:"]');
      errorEl.innerHTML = 'Photo upload is coming soon — for now, please text photos of the damage' + (sms ? ' to <a href="' + sms.getAttribute('href') + '">us</a>' : '') + '.';
      return;
    }

    function showError(msg) { errorEl.textContent = msg || ''; errorEl.hidden = !msg; }
    function busy() { return items.some(function (i) { return i.status === 'uploading'; }); }
    function sync() {
      var done = items.filter(function (i) { return i.status === 'done'; });
      urlsField.value = done.map(function (i, n) { return 'Photo ' + (n + 1) + ': ' + i.url; }).join('\n');
      wrap.classList.toggle('is-full', items.length >= max);
      if (submit) {
        submit.disabled = busy();
        var label = submit.querySelector('span') || submit;
        if (!submit.dataset.submitLabel) submit.dataset.submitLabel = label.textContent;
        label.textContent = busy() ? 'Uploading photos…' : submit.dataset.submitLabel;
      }
    }

    function addFiles(fileList) {
      showError('');
      var files = Array.prototype.filter.call(fileList, function (f) { return /^image\//.test(f.type) || /\.(heic|heif)$/i.test(f.name); });
      if (files.length < fileList.length) showError('Only image files can be added.');
      var room = max - items.length;
      if (files.length > room) { showError('You can add up to ' + max + ' photos.'); files = files.slice(0, room); }
      files.forEach(function (file) {
        if (file.size > MAX_BYTES) { showError(file.name + ' is too large (max 20 MB).'); return; }
        var item = { id: ++seq, status: 'uploading' };
        var li = document.createElement('li');
        li.className = 'photo-upload__item is-uploading';
        li.innerHTML = '<img alt=""><span class="photo-upload__status">Uploading…</span><button type="button" class="photo-upload__remove" aria-label="Remove photo">×</button>';
        var img = li.querySelector('img');
        try { img.src = URL.createObjectURL(file); } catch (e) {}
        li.querySelector('button').addEventListener('click', function () {
          items = items.filter(function (i) { return i !== item; });
          li.remove(); sync();
        });
        item.el = li; items.push(item); list.appendChild(li); sync();

        resize(file).then(function (out) {
          var fd = new FormData();
          fd.append('file', out);
          fd.append('upload_preset', wrap.dataset.preset);
          fd.append('folder', 'propaint-enquiries');
          return fetch(endpoint, { method: 'POST', body: fd });
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j.error && j.error.message) || 'Upload failed'); return j; }); })
          .then(function (j) {
            if (items.indexOf(item) === -1) return;
            item.status = 'done'; item.url = j.secure_url;
            li.className = 'photo-upload__item is-done';
            li.querySelector('.photo-upload__status').textContent = 'Added';
            sync();
          })
          .catch(function () {
            if (items.indexOf(item) === -1) return;
            item.status = 'error';
            li.className = 'photo-upload__item is-error';
            li.querySelector('.photo-upload__status').textContent = 'Failed – remove';
            showError('A photo didn’t upload. Remove it and try again, or text it to us.');
            sync();
          });
      });
      input.value = '';
    }

    input.addEventListener('change', function () { addFiles(input.files); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.add('is-dragover'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); wrap.classList.remove('is-dragover'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });

    if (form) form.addEventListener('submit', function (e) {
      if (busy()) { e.preventDefault(); showError('Please wait for your photos to finish uploading.'); return; }
      var ok = items.filter(function (i) { return i.status === 'done'; }).length;
      if (required && ok === 0) { e.preventDefault(); showError('Please add at least one photo of the damage.'); drop.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });
})();
